import { serviceQueryKeys as e } from "./useServiceQueryKeys.mjs";
import { useSuspenseQuery as t } from "@maat/store-hooks";
import { servicesApi as n } from "@maat/api-main";
//#region src/services/useServiceDetailQuery.ts
var r = (r) => t({
	queryKey: e.detail(r),
	queryFn: () => n.getService(r)
});
//#endregion
export { r as useServiceDetailQuery };
